export default {
    data() {
        return {
            nextKey: 1,
        };
    },
    computed: {
        totalRiskPeriodDays: {
            get() {
                if (this.submission) {
                    if (this.submission.total_risk_period === null) {
                        return '';
                    }
                    return this.submission.total_risk_period % 365;
                }
                return null;
            },
            set(days) {
                if (this.submission) {
                    this.setTotalRiskPeriod(this.totalRiskPeriodYears, days);
                }
            }
        },
        totalRiskPeriodYears: {
            get() {
                if (this.submission) {
                    if (this.submission.total_risk_period === null) {
                        return '';
                    }
                    return (this.submission.total_risk_period - this.totalRiskPeriodDays) / 365;
                }
                return null;
            },
            set(years) {
                if (this.submission) {
                    this.setTotalRiskPeriod(years, this.totalRiskPeriodDays);
                }
            }
        },
        currencyCode() {
            if (this.currencies && this.submission) {
                const selectedCurrency = this.currencies.find(currency => this.submission.currency_id === currency.id) || {};
                return selectedCurrency.code || '';
            }
            return '';
        },
        clients() {
            if (this.companies) {
                return this.companies.filter(c => c.company_type === 'client');
            }
            return [];
        },
        selectedGuarantorIds() {
            if (this.submission && Array.isArray(this.submission.guarantors)) {
                return this.submission.guarantors.map(guarantor => {
                    return this.submission.risk_type === 'manual_submission'
                        ? guarantor.guarantor_id
                        : guarantor.pivot.guarantor_id
                });
            }
            return [];
        },
        selectedObligorIds() {
            if (this.submission && Array.isArray(this.submission.obligors)) {
                return this.submission.obligors.map(obligor => {
                    return this.submission.risk_type === 'manual_submission'
                        ? obligor.obligor_id
                        : obligor.pivot.obligor_id
                });
            }
        },
        selectedFacility() {
            if (typeof this.facilities === 'undefined') {
                return null;
            }
            return this.facilities.find(facility => facility.id === this.submission.facility_id);
        },
        selectedCategory() {
            if (typeof this.categories === 'undefined') {
                return null;
            }
            return this.categories.find(category => category.id === this.submission.category_id);
        },
        hasNoObligor() {
            if (this.products && this.submission) {
                return (typeof (this.products.find(p => p.id === this.submission.product_id && p.has_no_obligor)) !== 'undefined');
            }
            return true;
        },
        facilityBasedProducts() {
            if (this.selectedFacility === undefined || this.submission.facility_id < 1) {
                return this.products || [];
            }

            return this.products.filter(product => this.selectedFacility.product_ids.includes(product.id));
        },
        filteredFacilities() {
            if (this.submission && this.facilities) {
                const clientCompanyId = this.role === 'client' ? this.$root.user.company.id : this.submission.client_company_id;
                return [
                    ...this.facilities.filter(
                        facility => {
                            return facility.client_company.id === clientCompanyId &&
                                (facility.status === 1 || facility.id === this.submission.facility_id);
                        }
                    )
                ];
            }
            return [];
        },
        filteredEntities() {
            if (this.submission && this.facilities) {
                const facilityId = this.submission.facility_id;
                if (this.isKnownFacility === false) {
                    return this.entities.filter(entity => entity.client_company_id === this.submission.client_company_id);
                }
                return this.facilities.find(facility => facility.id === facilityId)?.active_entities || [];
            }
        },
        filteredCategories() {
            if (this.categories) {
                return this.categories.filter(category => this.facilityBasedProducts.some(product => product.category_id === category.id));
            }
        },
        filteredProducts() {
            if (this.submission) {
                return this.facilityBasedProducts.filter(product => product.category_id === this.submission.category_id);
            }
        },
        filteredObligors() {
            const filteredObligors = [];

            if (this.submission && this.obligors && Array.isArray(this.submission.obligors)) {
                this.submission.obligors.forEach((obligorRisk, index) => {
                    const selectedObligorIds = this.submission.obligors.slice(0, index).map(obligor => {
                        return this.submission.risk_type === 'manual_submission'
                            ? obligor.obligor_id
                            : obligor.pivot.obligor_id
                    });

                    const countryId = obligorRisk?.country_id;
                    if (countryId) {
                        filteredObligors[index] = this.obligors.filter(obligor => obligor.country_id === countryId &&
                            ![...this.selectedGuarantorIds, ...selectedObligorIds].includes(obligor.id));
                    }
                });
            }

            return filteredObligors;
        },
        filteredGuarantors() {
            let filteredGuarantors = [];
            if (this.submission && this.obligors && Array.isArray(this.submission.guarantors)) {
                this.submission.guarantors.forEach((guarantorRisk, index) => {
                    const selectedGuarantorIds = this.submission.guarantors.slice(0, index).map(guarantor => {
                        return this.submission.risk_type === 'manual_submission'
                            ? guarantor.guarantor_id
                            : guarantor.pivot.guarantor_id
                    });
                    filteredGuarantors[index] = this.obligors.filter(obligor => obligor.country_id === guarantorRisk.country_id &&
                        ![...this.selectedObligorIds, ...selectedGuarantorIds].includes(obligor.id));
                });
            }
            return filteredGuarantors;
        },
    },
    methods: {
        getUniqueKey() {
            const {nextKey} = this;
            this.nextKey++;
            return nextKey;
        },
        getDefaultObligor() {
            return this.submission.risk_type === 'manual_submission'
                ?                {
                    key: this.getUniqueKey(),
                    country_id: null,
                    obligor_id: null,
                    pivot: {
                        sub_limit: null
                    }
                }
                :                {
                    key: this.getUniqueKey(),
                    country_id: null,
                    pivot: {
                        obligor_id: null,
                        sub_limit: null
                    }
                }
        },
        getDefaultGuarantor() {
            return this.submission.risk_type === 'manual_submission'
                ?                {
                    key: this.getUniqueKey(),
                    country_id: null,
                    guarantor_id: null,
                }
                :                {
                    key: this.getUniqueKey(),
                    country_id: null,
                    pivot: {
                        guarantor_id: null,
                    }
                }
        },
        addObligorSection() {
            this.submission.obligors.push(this.getDefaultObligor());
        },
        removeObligorSection(index) {
            this.submission.obligors.splice(index, 1);
        },
        addGuarantorSection() {
            this.submission.guarantors.push(this.getDefaultGuarantor());
        },
        removeGuarantorSection(index) {
            this.submission.guarantors.splice(index, 1);
        },
        productHasField(fieldName) {
            if (this.submission.product_id) {
                const product = this.products.find(prod => prod.id === this.submission.product_id);
                if (product) {
                    return product.config?.questions?.some(q => q.field === fieldName && q.is_product_data);
                }
            }
            return false;
        },
        setTotalRiskPeriod(years, days) {
            // set values to zero if false, NaN, etc.
            years = years || 0;
            days = days || 0;
            this.submission.total_risk_period = (Number(years) * 365) + Number(days);
        },
    }
}
